import React from 'react';
import { useFormik } from "formik";
import * as Yup from "yup";
// import Logo from '../../assets/images/logo.svg';
import { Form, Row, Col, Button, Spinner } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import '../ForgotPassword/forgotPassword.scss';
import '../ResetPassword/resetPassword.scss';
import PwdReset from '../../assets/images/pwd-reset-icon.svg';
import EyeIcon from '../../assets/images/eye_icon.svg';
import { Link } from 'react-router-dom';
import { RESET_PASSWORD } from '../../gql/auth/mutation';

function ResetPassword({ location }) {

    const [passwordShown, setPasswordShown] = useState(false);
    const [confpasswordShown, setConfPasswordShown] = useState(false);
    // const [confirmationShown, setConfirmationShown] = useState(false);
    const [resetPasswordHandler, { loading, error, data }] = useMutation(RESET_PASSWORD)
    const [code, setCode] = useState('')

    useEffect(() => {
        let fetchedCode = location.search.split('=')[1]
        setCode(fetchedCode)
        // eslint-disable-next-line
    }, [])

    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };

    const toggleConfPassword = () => {
        setConfPasswordShown(!confpasswordShown);
    };

    const formik = useFormik({
        initialValues: {
            password: "",
            confPassword: "",
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .required("Password is required")
                .min(8, "Password is too short - should be 8 chars minimum.")
                .matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/, "Password must contain one uppercase letter, one lowercase letter, one number and one special character."),
            confPassword: Yup.string().required("Confirm password is required").when("password", {
                is: val => (val && val.length > 0 ? true : false),
                then: Yup.string().oneOf(
                    [Yup.ref("password")],
                    "Both passwords need to be same." 
                )
            })
        }),
        onSubmit: (values) => {
            try {
                resetPasswordHandler({
                    variables: {
                        resetPasswordInput: {
                            password: values.password,
                            confirmPassword: values.confPassword,
                            resetToken: code
                        }
                    }
                })
            }
            catch (e) {
                console.error(e)
            }
        }
    })


    let errorMessage = '';
    if (error) {
        
        if (error.message) {
            errorMessage = error.message
        }
        if (!error.message) {
            errorMessage = "Something Went Wrong !"
        }
    }

    return (
        <div className='forgot-password reset-password'>
            {
                data ? 
                (
                    <div className="show-block confirmation-div">
                    <img src={PwdReset} alt="icon" />
                    <h2>Password reset</h2>
                    <p>Your password has been succesfully reset. Click below to log in.</p>
                    <Link to='/'  className='solid-button'>Login</Link>
                </div>
                )
                :
                (
                    <div className="show-block forgot-password-wrapper">
                    {/* <img className='logo' src={Logo} alt="Omnioutreach" /> */}
                    <h2>Create New Password</h2>
    
                    <Form className="logInForm" onSubmit={formik.handleSubmit}>
                        <Row className="mb-4">
                            {
                                errorMessage && <p className='error' >{errorMessage}</p>
                            }
                            <Form.Group className="pwd-wrapper" as={Col} md="12" controlId="password">
                                <Form.Label>New Password</Form.Label>
                                <Form.Control
                                    name="password"
                                    type={passwordShown ? "text" : "password"}
                                    placeholder="at least 8 characters"
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className={formik.errors.password && formik.touched.password && "error"}
                                />
                                <span className={passwordShown ? "hide-pwd password-show" : "show-pwd password-show"} onClick={togglePassword}><img className="view-icon" src={EyeIcon} alt="view" /></span>
                                {formik.errors.password && formik.touched.password && (
                                    <div className="input-feedback">{formik.errors.password}</div>
                                )}
                            </Form.Group>
                        </Row>
                        <Row className="mb-4">
                            <Form.Group className="pwd-wrapper" as={Col} md="12" controlId="confPassword">
                                <Form.Label>Confirm New Password</Form.Label>
                                <Form.Control
                                    name="confPassword"
                                    type={confpasswordShown ? "text" : "password"}
                                    // placeholder="Confirm new password"
                                    value={formik.values.confPassword}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className={formik.errors.confPassword && formik.touched.confPassword && "error"}
                                />
                                <span className={confpasswordShown ? "hide-pwd password-show" : "show-pwd password-show"} onClick={toggleConfPassword}><img className="view-icon" src={EyeIcon} alt="view" /></span>
                                {formik.errors.confPassword && formik.touched.confPassword && (
                                    <div className="input-feedback">{formik.errors.confPassword}</div>
                                )}
                            </Form.Group>
                        </Row>
                        {
                            (loading && !error) ?
                            <Button className='solid-button'>Reset Password
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                            </Button>
                            :
                            <Button className='solid-button' type="submit" >Reset Password</Button>
    
                        }
                    </Form>
                    <p className='back-to-login'><Link to='/'>Back to Login</Link></p>
                </div>
                )
            }
        </div>
    )
}

export default ResetPassword